<app-header/>
<div class="reset">
    <div class="reset_top text-center">
        <div class="bg_6 inline_padding2 reset_top_box">
            <div class="reset_top_box_inner">
                <div class="inline_padding3">
                    <span class="text_style_5">Reset Password</span>
                </div>
            </div>
        </div>
    </div>
    <form [formGroup]="resetpswdForm" (ngSubmit)="ResetPassword()">
        <div class="p-x-200 pswd_section_bottom_head">
          <div class="pswd_section_bottom_head_box">
            <div class="pswd_section_bottom_head_box_input2">
              <div class="dis-block-1 p-top-18 p-x-20">
                <label for="newPassword" class="dis-flex-4 text_grey_2">New Password</label>
                <input type="password" id="newPassword" formControlName="newpassword"
                       class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                       placeholder="Enter New Password" required>
              </div>
              <div class="dis-block-1 p-top-18 p-x-20">
                <label for="confirmPassword" class="dis-flex-4 text_grey_2">Confirm New Password</label>
                <input type="password" id="confirmPassword" formControlName="password"
                       class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                       placeholder="Enter Confirm New Password" required>
              </div>
            </div>
          </div>
          <div *ngIf="passwordMismatch" class="error-message">
            Passwords do not match.
          </div>
          <div class="p-x-20 pswd_section_bottom_head_btn p-top-40 dis-flex-2">
            <button type="submit" class="text_white_7 button_blue_4">send</button>
          </div>
        </div>
      </form>
      
    <div class=" p-top-132 m-t-25-neg"></div>
</div>

<app-footer/>